import { useEffect, useState } from "react";
import { Input, Button, Row, Col, Card, CardBody } from "reactstrap";
import { API } from "../../../api/API";
import { getData } from "../../../CommonElements/Functions/PostGetFun";
import CommonTableNew from "../../Tables/ReactstrapTables/BasicTables/Common/CommonTableNew";
import TreeModel from "./AttendanceTable/TreeModel";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import FeatherIconCom from "../../../Utils/CommonComponents/CommonIcons/FeatherIconCom";
import { Modal, ModalHeader, ModalBody, ModalFooter, Label, FormGroup } from 'reactstrap';
import MonthDropdown from "../../CommonCompo/MonthDropdown";

type AttendanceMeProps = {
    employeeIdProp?: number;
    tdate?: string;
    positionId?: number;
};
export default function AttendanceMe({ employeeIdProp, tdate, positionId }: AttendanceMeProps) {
    const serverUrl = localStorage.getItem('serverUrl');
    const APP_TOKEN = localStorage.getItem('appToken');
    const [attendanceData, setAttendanceData] = useState([]);
    const [kpiData, setKpiData] = useState<any>(null);

    const [displayedData, setDisplayedData] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [selectedIds, setSelectedIds] = useState<(string | number)[]>([]);
    const [loading, setLoading] = useState(true);
    const [selectedMonth, setSelectedMonth] = useState<string>('');

    // useEffect(() => {
    //     fetchAttendanceData();
    // }, [selectedIds]);
    useEffect(() => {
        fetchAttendanceData();
    }, [tdate, employeeIdProp, selectedMonth]); // optional dependencies

    useEffect(() => {
        fetchKpiData();
    }, [tdate, selectedMonth]); // optional dependencies

    const fetchAttendanceData = async () => {
        if (!serverUrl || !APP_TOKEN) return;
        setLoading(true);

        const urlAttendance = `${serverUrl}${API.getEmployeeAttendance}`;
        const { status, data } = await getData(urlAttendance, true, {
            employee_id: employeeIdProp,
            moye: selectedMonth
        });

        if (status === 200 && Array.isArray(data?.data)) {
            setAttendanceData(data.data);
            setDisplayedData(data.data);
        } else {
            setAttendanceData([]);
            setDisplayedData([]);
        }

        setLoading(false);
    };

    const fetchKpiData = async () => {
        if (!serverUrl || !APP_TOKEN) return;
        setLoading(true);

        const urlKpis = `${serverUrl}${API.getActivityKpis}`;
        const moye = tdate ? `${tdate.split('-')[1]}-${tdate.split('-')[0]}` : '';
console.log(positionId, 'positionId', selectedMonth, 'selectedMonth');

        const { status, data } = await getData(urlKpis, true, {
            position_id: `${positionId}`,
            moye: selectedMonth,
            // type and rollup optional
        });
        // console.log(data, selectedMonth, 'datakpis');

        if (status === 200 && data?.data) {
            setKpiData(data.data);
        } else {
            setKpiData(null);
        }

        setLoading(false);
    };



    useEffect(() => {
        const lower = searchText.toLowerCase();
        const filtered = attendanceData.filter((item) =>
            Object.values(item).some(val =>
                String(val).toLowerCase().includes(lower)
            )
        );
        setDisplayedData(filtered);
    }, [searchText, attendanceData]);

    const handleExportToExcel = () => {
        if (displayedData.length === 0) return;
        const worksheet = XLSX.utils.json_to_sheet(displayedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Attendance Report');
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(blob, `Attendance_${new Date().toISOString().split("T")[0]}.xlsx`);
    };
    // console.log(displayedData, '===========================');

    const keys = displayedData.length > 0 ? Object.keys(displayedData[0]) : [];
    const headData = [
        { id: '1', head: 'Attendance Date', key: 'AttendanceDate', sortKey: 'AttendanceDate' },
        { id: '2', head: 'Company ID', key: 'CompanyId', sortKey: 'CompanyId' },
        { id: '3', head: 'Employee ID', key: 'EmployeeId', sortKey: 'EmployeeId' },
        { id: '4', head: 'Shift Minutes', key: 'ShiftMins', sortKey: 'ShiftMins' },
        { id: '5', head: 'Start Time', key: 'StartTime', sortKey: 'StartTime' },
        { id: '6', head: 'End Time', key: 'EndTime', sortKey: 'EndTime' },
        { id: '7', head: 'Start Town Name', key: 'StartTownName', sortKey: 'StartTownName' },
        { id: '8', head: 'End Town Name', key: 'EndTownName', sortKey: 'EndTownName' },
        { id: '9', head: 'Total Travelled KM', key: 'TotalTravelledKM', sortKey: 'TotalTravelledKM' },
        { id: '10', head: 'Start Address', key: 'StartAddress', sortKey: 'StartAddress' },
        { id: '11', head: 'End Address', key: 'EndAddress', sortKey: 'EndAddress' },
        { id: '12', head: 'Start Itown ID', key: 'StartItownid', sortKey: 'StartItownid' },
        { id: '13', head: 'End Itown ID', key: 'EndItownid', sortKey: 'EndItownid' },
        { id: '14', head: 'Start LatLng', key: 'StartLatlng', sortKey: 'StartLatlng' },
        { id: '15', head: 'End LatLng', key: 'EndLatlng', sortKey: 'EndLatlng' },
        { id: '16', head: 'Expense Generated', key: 'ExpenseGenerated', sortKey: 'ExpenseGenerated' },
        { id: '17', head: 'Expense ID', key: 'ExpenseId', sortKey: 'ExpenseId' },
        { id: '18', head: 'Expense Remark', key: 'ExpenseRemark', sortKey: 'ExpenseRemark' },
        { id: '19', head: 'Is Updated', key: 'IsUpdated', sortKey: 'IsUpdated' },
        { id: '20', head: 'Joint Employee', key: 'JointEmp', sortKey: 'JointEmp' },
        { id: '21', head: 'Outlet Count', key: 'OutletCount', sortKey: 'OutletCount' },
        { id: '22', head: 'Status', key: 'Status', sortKey: 'Status' },
        { id: '23', head: 'Visited Itown ID', key: 'VisitedItownid', sortKey: 'VisitedItownid' },
        { id: '24', head: 'Remark', key: 'Remark', sortKey: 'Remark' },
    ];

    // inside your component
    const [modalOpen, setModalOpen] = useState(false);
    const [editRow, setEditRow] = useState<any>(null);

    const openEditModal = (row: any) => {
        setEditRow(row);
        setModalOpen(true);
    };

    const closeEditModal = () => {
        setModalOpen(false);
        setEditRow(null);
    };

    // update function if needed
    const handleChange = (field: string, value: any) => {
        setEditRow((prev: any) => ({ ...prev, [field]: value }));
    };


    return (
        <Card className="p-3">
            <div className='d-flex justify-content-between align-items-center pt-2 pb-2'>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <Col xs="auto">
                        <Input
                            type="text"
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            placeholder="Search here"
                        />
                    </Col>
                    <button className="btn btn-sm btn-primary d-flex align-items-center" onClick={handleExportToExcel}>
                        <FeatherIconCom iconName="Download" size={14} className="text-light" />
                        <span className="px-2" style={{ fontSize: 14 }}>Export</span>
                    </button></div>
                <MonthDropdown onChange={(value) => setSelectedMonth(value)} />
            </div>

            {!kpiData ? (
                <div className="text-center p-4"> KPI Data not available</div>
            ) : (
                <Row>

                    <Col md={3}>
                        <Card>
                            <CardBody>
                                <div className="customer-card d-flex justify-content-between align-items-center b-l-primary border-2">
                                    <div className='ms-3'>
                                        <h6 className="mb-1" style={{ fontSize: '0.9rem', color: '#888', marginBottom: '4px' }}>
                                            Total Calls Done
                                        </h6>
                                        <h3>{kpiData?.TotalCalls || 0}</h3>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>

                    {/* <Col md={3}>
                        <Card>
                            <CardBody>
                                <div className="customer-card d-flex justify-content-between align-items-center b-l-primary border-2">
                                    <div className='ms-3'>
                                        <h6 className="mb-1" style={{ fontSize: '0.9rem', color: '#888', marginBottom: '4px' }}>
                                            Outlets Covered
                                        </h6>
                                        <h3>{kpiData?.OutletsCovered || 0}</h3>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col> */}

                    <Col md={3}>
                        <Card>
                            <CardBody>
                                <div className="customer-card d-flex justify-content-between align-items-center b-l-primary border-2">
                                    <div className='ms-3'>
                                        <h6 className="mb-1" style={{ fontSize: '0.9rem', color: '#888', marginBottom: '4px' }}>
                                            Call Average
                                        </h6>
                                        <h3>
                                            {kpiData?.AttendanceDays && kpiData.AttendanceDays !== 0
                                                ? (kpiData.TotalCalls / kpiData.AttendanceDays).toFixed(2)
                                                : '0.00'}
                                        </h3>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>

                    <Col md={3}>
                        <Card>
                            <CardBody>
                                <div className="customer-card d-flex justify-content-between align-items-center b-l-primary border-2">
                                    <div className='ms-3'>
                                        <h6 className="mb-1" style={{ fontSize: '0.9rem', color: '#888', marginBottom: '4px' }}>
                                            Visit Frequency
                                        </h6>
                                        <h3>{kpiData?.VfCoverage || 0} / {kpiData?.TotalVfq || 0}</h3>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>

                    <Col md={3}>
                        <Card>
                            <CardBody>
                                <div className="customer-card d-flex justify-content-between align-items-center b-l-primary border-2">
                                    <div className='ms-3'>
                                        <h6 className="mb-1" style={{ fontSize: '0.9rem', color: '#888', marginBottom: '4px' }}>
                                            {kpiData?.DefaultOutletName || 'Outlet'} Compliance
                                        </h6>
                                        <h3>{kpiData?.OutletsCovered || 0} / {kpiData?.TotalOutlets || 0}</h3>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>

                     <Col md={3}>
                        <Card>
                            <CardBody>
                                <div className="customer-card d-flex justify-content-between align-items-center b-l-primary border-2">
                                    <div className='ms-3'>
                                        <h6 className="mb-1" style={{ fontSize: '0.9rem', color: '#888', marginBottom: '4px' }}>
                                            Total Travelled KM
                                        </h6>
                                        <h3>{kpiData?.TotalTravelledKm || 0}</h3>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>

                </Row>

            )}
            {/* <div className='p-3'>
                <Row className="align-items-center justify-content-end mb-3">



                </Row>
            </div> */}
            {/* <MonthDropdown onChange={(value) => setSelectedMonth(value)} /> */}

            {loading ? (
                <div className="text-center">Loading...</div>
            ) : (
                <CommonTableNew
                    caption=""
                    headData={headData}
                    data={displayedData}
                    renderRow={(row, rowIndex) => (
                        <tr key={rowIndex}>
                            <td>{row.AttendanceDate}</td>
                            {/* <td>{row.AttendanceId}</td> */}
                            <td>{row.CompanyId}</td>
                            {/* <td>{row.CreatedAt}</td> */}
                            <td>{row.EmployeeId}</td>
                            <td>{row.ShiftMins ? `${parseInt(row.ShiftMins)} Min` : '-'}</td>
                            <td>{row.StartTime ? new Date(`1970-01-01T${row.StartTime}`).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true }) : '-'}</td>
                            <td>{row.EndTime ? new Date(`1970-01-01T${row.EndTime}`).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true }) : '-'}</td>
                            <td>{row.StartTownName ?? '-'}</td>
                            <td>{row.EndTownName ?? '-'}</td>
                            <td>{row.TravelledDistance ?? '-'}</td>
                            <td>{row.StartAddress ?? '-'}</td>
                            <td>{row.EndAddress ?? '-'}</td>
                            <td>{row.StartItownid ?? '-'}</td>
                            <td>{row.EndItownid ?? '-'}</td>
                            <td>{row.StartLatlng ?? '-'}</td>
                            <td>{row.EndLatlng ?? '-'}</td>
                            <td>{row.ExpenseGenerated ? 'Yes' : 'No'}</td>
                            <td>{row.ExpenseId ?? '-'}</td>
                            <td>{row.ExpenseRemark ?? '-'}</td>
                            <td>{row.IsUpdated ? 'Updated' : 'Not Updated'}</td>
                            <td>{row.JointEmp ?? '-'}</td>
                            <td>{row.OutletCount}</td>

                            <td>{row.Status}</td>
                            {/* <td>{row.UpdatedAt ?? '-'}</td> */}
                            <td>{row.VisitedItownid ?? '-'}</td>
                            <td>{row.Remark}</td>
                            {/* <td>
                                <Button color="primary" size="sm" onClick={() => openEditModal(row)}>Edit</Button>
                            </td> */}

                        </tr>
                    )}
                />

            )}
            <Modal isOpen={modalOpen} toggle={closeEditModal}>
                <ModalHeader toggle={closeEditModal}>Edit Attendance Data</ModalHeader>
                <ModalBody>
                    {editRow &&
                        Object.entries(editRow).map(([key, value]) => {
                            let inputType: "text" | "number" = "text";
                            if (typeof value === "number") inputType = "number";

                            // Boolean → render select box
                            if (typeof value === "boolean") {
                                return (
                                    <FormGroup key={key}>
                                        <Label>{key}</Label>
                                        <Input
                                            type="select"
                                            value={value ? "Yes" : "No"}
                                            onChange={(e) =>
                                                handleChange(key, e.target.value === "Yes")
                                            }
                                        >
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </Input>
                                    </FormGroup>
                                );
                            }
                            // String/Number → render text/number input
                            return (
                                <FormGroup key={key}>
                                    <Label>{key}</Label>
                                    <Input
                                        type={inputType}
                                        value={value !== null && value !== undefined ? String(value) : ""}
                                        onChange={(e) =>
                                            handleChange(
                                                key,
                                                inputType === "number"
                                                    ? Number(e.target.value)
                                                    : e.target.value
                                            )
                                        }
                                    />
                                </FormGroup>
                            );
                        })}

                </ModalBody>
                <ModalFooter>
                    <Button color="success" onClick={() => {
                        // console.log('✅ Updated Row:', editRow);
                        closeEditModal();
                    }}>Save</Button>
                    <Button color="secondary" onClick={closeEditModal}>Cancel</Button>
                </ModalFooter>
            </Modal>


        </Card>
    );
}
